import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  width: "100%",
  display: "flex",
  height: "190px",
  alignItems: "center",
  padding: "32px 40px",
  justifyContent: "space-between",
  alignSelf: "stretch",
  background:
    "linear-gradient(91deg, rgba(255, 255, 255, 0.20) -4.38%, rgba(81, 42, 204, 0.20) 53.58%, rgba(255, 255, 255, 0.20) 113.82%)",

  [props.theme.breakpoints.down("lg")]: {
    padding: "32px 40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "32px 16px",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: props.type == "desc" ? "30px" : "48px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",

  "& i": {
    color: "#512ACC",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    textAlign: props.type == "desc" ? "left" : "left",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
    maxWidth: "unset",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  height: "56px",
  padding: "0px 40px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "8px",
  color: "rgba(0,0,0,0.87)",
  boxShadow: "0px 2px 4px 0px rgba(104, 77, 0, 0.40)",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "20px",
  fontWeight: 700,
  fontStyle: "normal",
  lineHeight: "120%",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  background: "#FFDA07",
  maxWidth: "400px",

  "&:hover": {
    backgroundColor: "#FFDA07",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "1rem",
    lineHeight: "150%",
    letterSpacing: "0.1px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "280px",
    paddingInline: "1rem",
    height: "48px",
  },
}));
